export default function createSubscriptionContentByResource(data) {
  return {
    promotable: data.promotable,
    subscriptionOrders: data.subscription_orders
      ? data.subscription_orders
      : [],
  };
}
